const SepticPumpIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 14.8164 21.6162"
    fill="none"
    {...props}
  >
    <path
      d="M3.00806 14.8081H11.8083M3.00806 10.8081H11.8083M3.00806 6.8081H11.8083M7.4082 0.75C11.0852 0.75 14.066 2.07344 14.0664 3.70605V17.9102C14.0664 19.5429 11.0855 20.8662 7.4082 20.8662C3.73092 20.8662 0.750019 19.5429 0.75 17.9102V3.70605C0.750446 2.07344 3.73119 0.75 7.4082 0.75Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
  </svg>
);

export default SepticPumpIcon;
